import { directSalesPath } from 'Modules/directSales/routes';

export const journeys = {
  directSales: 'USA DS Customer',
};

export const journeyPaths = {
  [journeys.directSales]: directSalesPath,
};
